import { render, staticRenderFns } from "./DriftResolver.vue?vue&type=template&id=7caff545"
import script from "./DriftResolver.vue?vue&type=script&lang=ts"
export * from "./DriftResolver.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports